import React from 'react';
import { IconButton, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { MoonIcon, SunIcon } from '@chakra-ui/icons';

interface ColorModeSwitcherProps {
  size?: 'sm' | 'md' | 'lg';
}

const ColorModeSwitcher: React.FC<ColorModeSwitcherProps> = ({ size = 'lg' }) => {
  const { colorMode, toggleColorMode } = useColorMode();
  const iconColor = useColorModeValue('gray.700', 'gray.200');
  const hoverBg = useColorModeValue('gray.100', 'gray.700');

  return (
    <IconButton
      aria-label={colorMode === 'light' ? 'Activar modo oscuro' : 'Activar modo claro'}
      icon={colorMode === 'light' ? <MoonIcon /> : <SunIcon />}
      onClick={(e) => {
        e.stopPropagation();
        toggleColorMode();
      }}
      variant="ghost"
      size={size}
      color={iconColor}
      _hover={{ bg: hoverBg }}
    />
  );
};

export default ColorModeSwitcher; 